<template>
    <div>
        <top-navbar :padding="topPadding" :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="pt-5" v-show="hasNotice">
                <app-status :remote-version="appVersion" @show="appStatus = true"></app-status>
                <offline-status @show="offlineStatus = true"></offline-status>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <grades></grades>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Grades from './grades/Grades';
    import OfflineStatus from './offline/HomeStatus';
    import AppStatus from './offline/AppStatus';

    export default {

        components: {
            Grades, OfflineStatus, AppStatus
        },

        data() {
            return {
                appStatus: false,
                offlineStatus: false,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.grades'),
                    },
                ]
            },

            appVersion() {
                return this.$auth['config'].app_version
            },

            hasNotice() {
                return this.appStatus || this.offlineStatus
            },

            topPadding() {
                return this.hasNotice ? 4 : 6
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/socrates/api/front/dashboard/page/grades')
            .then(resp => {
                next(vm => {
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },
    }
</script>
